import type { IntlShape } from 'react-intl'

export default function getInclusionMinStayText(inclusion: App.OfferInclusion | App.PackageInclusion, intl: IntlShape) {
  const minDuration = inclusion?.minDuration
  const maxDuration = inclusion?.maxDuration

  if (minDuration && minDuration > 1 && minDuration !== maxDuration) {
    return intl.formatMessage(
      {
        id: 'CFodkXP/l1',
        defaultMessage: '({minDuration, plural, one {#+ night} other {#+ nights}})',
        description: 'Minimum stay text shown for an inclusion requiring multiple nights',
      },
      { minDuration: inclusion.minDuration },
    )
  }

  return ''
}
